export const SPEECH_PLAYBACK_RATE = 1.1;

// Fish renders at its natural pace. Apply the same pitch-preserving tempo to
// streamed speech and saved speech, without accelerating music or video.
export function setSpeechPlaybackRate(audio) {
  if (!audio) return;
  audio.preservesPitch = true;
  if ('webkitPreservesPitch' in audio) audio.webkitPreservesPitch = true;
  audio.defaultPlaybackRate = SPEECH_PLAYBACK_RATE;
  audio.playbackRate = SPEECH_PLAYBACK_RATE;
}
